export type DataSizeUnit =
  | "byte"
  | "kilobyte"
  | "megabyte"
  | "gigabyte"
  | "terabyte";

const KILO_BYTE = BigInt(1000);
const MEGA_BYTE = BigInt(1000 ** 2);
const GIGA_BYTE = BigInt(1000 ** 3);
const TERA_BYTE = BigInt(1000 ** 4);

export const getDataSize = (
  bytes: bigint,
): { value: number; unit: DataSizeUnit } => {
  if (bytes < KILO_BYTE) {
    return { value: Number(bytes), unit: "byte" };
  } else if (bytes < MEGA_BYTE) {
    return { value: Number(bytes) / 1000, unit: "kilobyte" };
  } else if (bytes < GIGA_BYTE) {
    return { value: Number(bytes / KILO_BYTE) / 1000, unit: "megabyte" };
  } else if (bytes < TERA_BYTE) {
    return { value: Number(bytes / MEGA_BYTE) / 1000, unit: "gigabyte" };
  } else {
    return { value: Number(bytes / GIGA_BYTE) / 1000, unit: "terabyte" };
  }
};
